const API_URL = process.env.REACT_APP_API_URL;

export function SocialLoginFunc(provider) {
    const allowedProviders = ["google", "facebook"];

    if (!allowedProviders.includes(provider)) {
        console.error("Invalid social login provider:", provider);
        return;
    }

    window.location.href = `${API_URL}/api/auth/${provider}/redirect`;
}